// LIST
export const FETCH_BUDGET = "app/BUDGET/FETCH_BUDGET";
export const FETCH_BUDGET_SUCCESS = "app/BUDGET/FETCH_BUDGET_SUCCESS";
export const FETCH_BUDGET_FAILURE = "app/BUDGET/FETCH_BUDGET_FAILURE";
// GET VIEW DATA
export const GET_VIEW_DATA = "app/BUDGET/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/BUDGET/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/BUDGET/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_BUDGET = "app/BUDGET/ADD_BUDGET";
export const ADD_BUDGET_SUCCESS = "app/BUDGET/ADD_BUDGET_SUCCESS";
export const ADD_BUDGET_FAILURE = "app/BUDGET/ADD_BUDGET_FAILURE";
// EDIT
export const EDIT_BUDGET = "app/BUDGET/EDIT_BUDGET";
export const EDIT_BUDGET_SUCCESS = "app/BUDGET/EDIT_BUDGET_SUCCESS";
export const EDIT_BUDGET_FAILURE = "app/BUDGET/EDIT_BUDGET_FAILURE";
// DELETE
export const DELETE_BUDGET = "app/BUDGET/DELETE_BUDGET";
export const DELETE_BUDGET_SUCCESS = "app/BUDGET/DELETE_BUDGET_SUCCESS";
export const DELETE_BUDGET_FAILURE = "app/BUDGET/DELETE_BUDGET_FAILURE";
// SET WEEK
export const SET_WEEK = "app/BUDGET/BUDGET SET_WEEK";
export const TOGGLE_BUDGET_CONFIRM = "app/BUDGET/BUDGET TOGGLE_BUDGET_CONFIRM";
// COPY
export const COPY_BUDGET = "app/BUDGET/COPY_BUDGET";
export const COPY_BUDGET_SUCCESS = "app/BUDGET/COPY_BUDGET_SUCCESS";
export const COPY_BUDGET_FAILURE = "app/BUDGET/COPY_BUDGET_FAILURE";
// COPY
export const BULK_UPDATE = "app/BUDGET/BULK_UPDATE";
export const BULK_UPDATE_SUCCESS = "app/BUDGET/BULK_UPDATE_SUCCESS";
export const BULK_UPDATE_FAILURE = "app/BUDGET/BULK_UPDATE_FAILURE";
//
export const GET_BUDGET_HISTORY = "app/BUDGET/GET_BUDGET_HISTORY";
export const GET_BUDGET_HISTORY_SUCCESS =
  "app/BUDGET/GET_BUDGET_HISTORY_SUCCESS";
export const GET_BUDGET_HISTORY_FAILURE =
  "app/BUDGET/GET_BUDGET_HISTORY_FAILURE";

export const TOGGLE_BUDGET_MODAL = "app/BUDGET/TOGGLE_BUDGET_MODAL";

export const TOGGLE_ADD_MODAL = "app/BUDGET/TOGGLE_ADD_MODAL";

export const TOGGLE_COPY_MODE = "app/BUDGET/TOGGLE_COPY_MODE";
export const SET_COPY_DATA = "app/BUDGET/SET_COPY_DATA";
